import { render, staticRenderFns } from "./redeem_point.vue?vue&type=template&id=91b84f08&"
import script from "./redeem_point.vue?vue&type=script&lang=js&"
export * from "./redeem_point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports